export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '惠美梨',
    url: 'https://huimeili.com',
    description: '惠美梨，精选优质梨果，皮薄汁多、清甜爽口，产地直供保障新鲜品质。无论是日常鲜食还是礼品馈赠，惠美梨都是您的首选。',
    foundingDate: '1996',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-XXX-XXXX',
      contactType: 'customer service',
      availableLanguage: 'Chinese',
    },
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'CN',
      addressLocality: '优质梨果核心产区',
    },
  };
}

export function getWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '惠美梨',
    url: 'https://huimeili.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://huimeili.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };
}

export function getWebPageSchema(name: string, description: string, url: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name,
    description,
    url,
    isPartOf: {
      '@type': 'WebSite',
      name: '惠美梨',
      url: 'https://huimeili.com',
    },
    about: {
      '@type': 'Organization',
      name: '惠美梨',
    },
  };
}

export function getBreadcrumbSchema(items: { name: string; url: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function getFAQSchema(faqs: { question: string; answer: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}

export function getArticleSchema(article: {
  title: string;
  description: string;
  url: string;
  datePublished: string;
  dateModified: string;
  author: string;
  imageUrl: string;
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.description,
    url: article.url,
    datePublished: article.datePublished,
    dateModified: article.dateModified,
    author: {
      '@type': 'Person',
      name: article.author,
    },
    publisher: {
      '@type': 'Organization',
      name: '惠美梨',
    },
    image: article.imageUrl,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': article.url,
    },
  };
}